export default __webpack_public_path__ + "static/media/p2.2f128f69.jpg";